import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Chart from 'react-apexcharts';

//Actions

import DashboardConstrucoesEstadosProposta from '../../../../utils/redux/actions/global/dashboard/GetDashConstrucoesEstadosPropostas';

const ConstrucoesEstadosPropostaChart = () => {
  const dispatch = useDispatch();

  const fetchConstrucoesEstadosProposta = () => {
    dispatch(DashboardConstrucoesEstadosProposta());
  };

  const estadosState = useSelector(
    (state) => state.dashboard.construcoesEstadosPropostas
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchConstrucoesEstadosProposta(), []);

  return (
    <>
      {estadosState ? (
        <Chart
          type="donut"
          width={400}
          height={400}
          series={estadosState && estadosState.series}
          options={{
            labels: estadosState && estadosState.labels,
            tooltip: {
              y: {
                formatter: (val) => {
                  return `${val} Obras`;
                },
              },
            },
            title: {
              text: "Construções - Propostas",
            },
            colors: ["#4FC0E8", "#8CC051", "#FF4A4A"],
          }}
        />
      ) : null}
    </>
  );
};

export default ConstrucoesEstadosPropostaChart;
